import httpService from '@Utils/httpService';

const baseUrl = 'api/Feedback';

/**
 * User-facing Feedback endpoints (AVA-349).
 * Mirrors MODS.Forge.Api/Controllers/Feedback/FeedbackController.cs.
 * Every call acts on the signed-in user only — there is no user id to pass.
 */
export default {
  /**
   * Should this user see the Feedback Prompt now? Called once per session start.
   * Response: { shouldPrompt: boolean }
   */
  getEligibility() {
    return httpService.get({ url: `${baseUrl}/eligibility` });
  },

  /**
   * Record a rating. Response: { submissionId: string }
   * Rejects with FEEDBACK_RATING_OUT_OF_RANGE / FEEDBACK_COMMENT_TOO_LONG.
   * @param {{ rating: number, comment: ?string }} data
   */
  submit(data) {
    return httpService.post({ url: baseUrl, data });
  },

  /**
   * Suppress the prompt for a week. Backs "Remind me in a week" and every
   * dismissal path. Response: { snoozedUntil: string }
   */
  snooze() {
    return httpService.post({ url: `${baseUrl}/snooze` });
  },
};
